var RefundComponent = /** @class */ (function () {
    function RefundComponent() {
    }
    RefundComponent.prototype.ngOnInit = function () {
    };
    return RefundComponent;
}());
export { RefundComponent };



// WEBPACK FOOTER //
// ./src/app/refund/refund.component.ts.pre-build-optimizer.js